module.exports = __webpack_public_path__ + "img/steps3.d642fb4a.svg";